export class UserConstants {
  static readonly Messages = {
    AccountChangeSuccessMessage: 'Account has been changed successfully',
    AccountSaveSuccessMessage: 'Account settings have been saved successfully',
    NoAccountFoundMessage:
      'We do not show any store locations associated with your account that match your search request. ' +
      'Please try again or contact the Customer Service department at 800.727.6331.'
  };
}
